import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockGadgetSubmissions } from '../data/mockData';
import { Search, Eye, PlusCircle, X, FileText, Printer } from 'lucide-react';
import { GadgetSubmission } from '../types';
export const OperatorProjnapanList: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [viewModalData, setViewModalData] = useState<GadgetSubmission | null>(null);
  const publishedSubmissions = mockGadgetSubmissions.filter(g => g.status === 'published');
  const filteredSubmissions = publishedSubmissions.filter(sub => {
    const term = searchTerm.toLowerCase();
    return sub.id.toLowerCase().includes(term) || sub.district.toLowerCase().includes(term) || sub.upazila.toLowerCase().includes(term) || sub.smarakNo && sub.smarakNo.toLowerCase().includes(term);
  });
  const handleNewSubmission = (sub: GadgetSubmission) => {
    navigate('/upload', {
      state: {
        fromProjnapan: true,
        projnapanId: sub.id,
        district: sub.district,
        upazila: sub.upazila,
        smarakNo: sub.smarakNo,
        moujaDetails: sub.moujaDetails
      }
    });
  };
  const ProjnapanDocument = ({
    data
  }: {
    data: GadgetSubmission;
  }) => <div className="bg-white mx-auto border border-slate-200" style={{
    width: '210mm',
    minHeight: '297mm',
    padding: '20mm'
  }} data-id="element-1088">
      {/* Header */}
      <div className="text-center mb-8 font-bengali" data-id="element-1089">
        <p className="text-base" data-id="element-1090">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার</p>
        <p className="text-base" data-id="element-1091">ভূমি মন্ত্রণালয়</p>
        <p className="text-base" data-id="element-1092">জরিপ-২ শাখা</p>
        <p className="text-base" data-id="element-1093">বাংলাদেশ সচিবালয়, ঢাকা</p>
        <p className="text-base font-serif" data-id="element-1094">www.minland.gov.bd</p>
      </div>

      {/* Reference & Date */}
      <div className="flex justify-between items-end mb-8 font-bengali text-sm" data-id="element-1095">
        <div data-id="element-1096">
          <p data-id="element-1097">নম্বর: {data.smarakNo || '৩১.০০.০০০০.০৮৯.৩৩.০০১.২৫.৩৭'}</p>
        </div>
        <div className="text-right" data-id="element-1098">
          <p data-id="element-1099">১৯ মাঘ ১৪৩১ বঙ্গাব্দ</p>
          <div className="flex items-center justify-end" data-id="element-1100">
            <span className="mr-2" data-id="element-1101">তারিখ:</span>
            <span data-id="element-1102">০২ ফেব্রুয়ারি ২০২৫ খ্রিস্টাব্দ</span>
          </div>
        </div>
      </div>

      {/* Title */}
      <div className="text-center mb-6 font-bengali" data-id="element-1103">
        <h2 className="text-lg font-bold underline underline-offset-4" data-id="element-1104">
          প্রজ্ঞাপন
        </h2>
      </div>

      {/* Legal Text */}
      <div className="mb-6 font-bengali text-justify leading-relaxed text-sm" data-id="element-1105">
        <p data-id="element-1106">
          The State Acquisition and Tenancy Act, 1950 (Act XXVIII of 1951) এর
          144(7) ধারা এবং Tenancy Rules, 1955 এর 34(2) বিধি অনুযায়ী
          গণপ্রজাতন্ত্রী বাংলাদেশ সরকার কর্তৃক এই মর্মে ঘোষণা করা যাচ্ছে যে,
          নিম্নবর্ণিত মৌজাসমূহের খতিয়ানসমূহ চূড়ান্তভাবে প্রকাশ করা হলোঃ
        </p>
      </div>

      {/* Table */}
      <div className="mb-12" data-id="element-1107">
        <table className="w-full border-collapse border border-black text-sm font-bengali text-center" data-id="element-1108">
          <thead data-id="element-1109">
            <tr data-id="element-1110">
              <th className="border border-black p-2 font-normal" data-id="element-1111">ক্রমিক নং</th>
              <th className="border border-black p-2 font-normal" data-id="element-1112">মৌজার নাম</th>
              <th className="border border-black p-2 font-normal" data-id="element-1113">
                জে. এল. নম্বর
              </th>
              <th className="border border-black p-2 font-normal" data-id="element-1114">শুরু নং</th>
              <th className="border border-black p-2 font-normal" data-id="element-1115">শেষ নং</th>
              <th className="border border-black p-2 font-normal" data-id="element-1116">
                খতিয়ান সংখ্যা
              </th>
              <th className="border border-black p-2 font-normal" data-id="element-1117">
                শীট সংখ্যা
              </th>
              <th className="border border-black p-2 font-normal" data-id="element-1118">
                উপজেলার নাম
              </th>
              <th className="border border-black p-2 font-normal" data-id="element-1119">জেলার নাম</th>
            </tr>
          </thead>
          <tbody data-id="element-1120">
            {data.moujaDetails.map((row, index) => {
            const bnIndex = (index + 1).toString().replace(/[0-9]/g, w => String.fromCharCode(w.charCodeAt(0) + 2486));
            const displayIndex = bnIndex.length === 1 ? `০${bnIndex}` : bnIndex;
            return <tr key={index} data-id="element-1121">
                  <td className="border border-black p-2" data-id="element-1122">{displayIndex}</td>
                  <td className="border border-black p-2" data-id="element-1123">{row.mouja}</td>
                  <td className="border border-black p-2" data-id="element-1124">{row.jlNumber}</td>
                  <td className="border border-black p-2" data-id="element-1125">
                    {row.khatianStartNo || '—'}
                  </td>
                  <td className="border border-black p-2" data-id="element-1126">
                    {row.khatianEndNo || '—'}
                  </td>
                  <td className="border border-black p-2" data-id="element-1127">
                    {row.totalKhatian}
                  </td>
                  <td className="border border-black p-2" data-id="element-1128">{row.totalSheet}</td>
                  <td className="border border-black p-2" data-id="element-1129">{row.upazila}</td>
                  <td className="border border-black p-2" data-id="element-1130">{row.district}</td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>

      {/* Signature 1 */}
      <div className="flex justify-end mb-12 font-bengali text-sm text-center" data-id="element-1131">
        <div data-id="element-1132">
          <p className="mb-12" data-id="element-1133">রাষ্ট্রপতির আদেশক্রমে,</p>
          <div className="border-b border-black w-40 mx-auto mb-2" data-id="element-1134"></div>
          <p data-id="element-1135">০২-০২-২০২৫</p>
          <p data-id="element-1136">&nbsp;</p>
          <p data-id="element-1137">উপসচিব</p>
          <p data-id="element-1138">০২৯৫৪০৯১৯</p>
          <p className="font-serif" data-id="element-1139">survey2@minland.gov.bd</p>
        </div>
      </div>

      {/* Distribution List */}
      <div className="font-bengali text-sm" data-id="element-1140">
        <div className="flex justify-between items-end mb-4" data-id="element-1141">
          <div data-id="element-1142">
            <p data-id="element-1143">নম্বর: {data.smarakNo || '৩১.০০.০০০০.০৮৯.৩৩.০০১.২৫.৩৭'}/১ (৭)</p>
          </div>
          <div className="text-right" data-id="element-1144">
            <p data-id="element-1145">১৯ মাঘ ১৪৩১ বঙ্গাব্দ</p>
            <div className="flex items-center justify-end" data-id="element-1146">
              <span className="mr-2" data-id="element-1147">তারিখ:</span>
              <span data-id="element-1148">০২ ফেব্রুয়ারি ২০২৫ খ্রিস্টাব্দ</span>
            </div>
          </div>
        </div>

        <p className="mb-2" data-id="element-1149">
          অবগতি/অবগতি ও প্রয়োজনীয় ব্যবস্থা গ্রহণের জন্য অনুলিপি প্রেরণ করা হলো
          (জ্যেষ্ঠতার ক্রমানুসারে নয়):
        </p>
        <ol className="list-none space-y-1 ml-2" data-id="element-1150">
          <li data-id="element-1151">
            ১। মহাপরিচালক (গ্রেড-১), মহাপরিচালক-এর দপ্তর, ভূমি রেকর্ড ও জরিপ
            অধিদপ্তর।
          </li>
          <li data-id="element-1152">
            ২। বিভাগীয় কমিশনার, বিভাগীয় কমিশনারের কার্যালয়, বিভাগীয়
            কমিশনারের কার্যালয়, {data.district}।
          </li>
          <li data-id="element-1153">
            ৩। জেলা প্রশাসক, জেলা প্রশাসকের কার্যালয়, জেলা প্রশাসকের কার্যালয়,{' '}
            {data.district}।
          </li>
          <li data-id="element-1154">
            ৪। উপ পরিচালক, উপপরিচালকের দপ্তর, বাংলাদেশ ফরম ও প্রকাশনা অফিস।
          </li>
          <li data-id="element-1155">
            ৫। জোনাল সেটেলমেন্ট অফিসার, জোনাল সেটেলমেন্ট অফিসার-এর দপ্তর, জোনাল
            সেটেলমেন্ট অফিস, {data.district}।
          </li>
          <li data-id="element-1156">
            ৬। সিস্টেম এনালিস্ট, সিকিউরিটি, অডিট ও কোয়ালিটি কন্ট্রোল (এসএকিউ),
            ভূমি মন্ত্রণালয়।
          </li>
          <li data-id="element-1157">৭। অফিস / মাস্টার কপি।</li>
        </ol>
      </div>

      {/* Footer Signature & QR */}
      <div className="flex justify-between items-end mt-12 font-bengali text-sm" data-id="element-1158">
        <div className="w-20 h-20 bg-slate-200 flex items-center justify-center border border-slate-300" data-id="element-1159">
          <span className="text-slate-400 font-bold" data-id="element-1160">QR</span>
        </div>
        <div className="text-center" data-id="element-1161">
          <div className="border-b border-black w-40 mx-auto mb-2" data-id="element-1162"></div>
          <p data-id="element-1163">০২-০২-২০২৫</p>
          <p data-id="element-1164">&nbsp;</p>
          <p data-id="element-1165">উপসচিব</p>
        </div>
      </div>
    </div>;
  return <div className="max-w-7xl mx-auto" data-id="element-1166">
      <div className="mb-6" data-id="element-1167">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-1168">প্রজ্ঞাপন তালিকা</h1>
        <p className="text-slate-500" data-id="element-1169">
          প্রকাশিত সকল প্রজ্ঞাপন দেখুন এবং নতুন ডাটা সাবমিশন শুরু করুন
        </p>
      </div>

      {publishedSubmissions.length === 0 ? <div className="card text-center py-20" data-id="element-1170">
          <FileText size={64} className="mx-auto text-slate-300 mb-4" data-id="element-1171" />
          <h2 className="text-xl font-semibold text-slate-700" data-id="element-1172">
            কোন প্রকাশিত প্রজ্ঞাপন নেই
          </h2>
          <p className="text-slate-500 mt-2" data-id="element-1173">
            প্রজ্ঞাপন প্রকাশিত হলে এখানে দেখা যাবে।
          </p>
        </div> : <div className="card overflow-hidden flex flex-col h-[calc(100vh-12rem)]" data-id="element-1174">
          <div className="p-4 border-b border-slate-200 bg-slate-50 flex space-x-4" data-id="element-1175">
            <div className="relative flex-1 max-w-md" data-id="element-1176">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} data-id="element-1177" />
              <input type="text" placeholder="আইডি, অবস্থান বা স্মারক নং দিয়ে অনুসন্ধান..." className="input-field pl-10 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1178" />
            </div>
          </div>

          <div className="flex-1 overflow-auto" data-id="element-1179">
            <table className="min-w-full divide-y divide-slate-200" data-id="element-1180">
              <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-1181">
                <tr data-id="element-1182">
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1183">
                    প্রজ্ঞাপন আইডি
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1184">
                    জেলা
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1185">
                    উপজেলা
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1186">
                    স্মারক নং
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1187">
                    মৌজা সংখ্যা
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1188">
                    প্রকাশের তারিখ
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-1189">
                    কার্যক্রম
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-200" data-id="element-1190">
                {filteredSubmissions.map(sub => <tr key={sub.id} className="hover:bg-slate-50" data-id="element-1191">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-1192">
                      {sub.id}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-1193">
                      {sub.district}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-1194">
                      {sub.upazila}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-indigo-700 font-medium" data-id="element-1195">
                      {sub.smarakNo || '—'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-1196">
                      {sub.moujaDetails.length}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-1197">
                      {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium" data-id="element-1198">
                      <div className="flex items-center justify-end space-x-2" data-id="element-1199">
                        <button onClick={() => setViewModalData(sub)} className="text-blue-600 hover:text-blue-900 p-1.5 bg-blue-50 rounded" title="বিস্তারিত দেখুন" data-id="element-1200">
                          <Eye size={16} data-id="element-1201" />
                        </button>
                        <button onClick={() => handleNewSubmission(sub)} className="inline-flex items-center px-3 py-1.5 bg-teal-600 text-white text-xs font-medium rounded hover:bg-teal-700 transition-colors" title="নতুন ডাটা সাবমিশন" data-id="element-1202">
                          <PlusCircle size={14} className="mr-1.5" data-id="element-1203" />
                          নতুন সাবমিশন
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {viewModalData && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1204">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] flex flex-col" data-id="element-1205">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-slate-50 rounded-t-lg" data-id="element-1206">
              <h2 className="text-lg font-bold text-slate-800" data-id="element-1207">
                প্রজ্ঞাপন — {viewModalData.id}
              </h2>
              <button onClick={() => setViewModalData(null)} className="text-slate-400 hover:text-slate-600" data-id="element-1208">
                <X size={20} data-id="element-1209" />
              </button>
            </div>
            <div className="overflow-y-auto flex-1 bg-slate-100 p-4" data-id="element-1210">
              <ProjnapanDocument data={viewModalData} data-id="element-1211" />
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 rounded-b-lg flex justify-end space-x-3" data-id="element-1212">
              <button onClick={() => setViewModalData(null)} className="btn-secondary" data-id="element-1213">
                বন্ধ করুন
              </button>
              <button onClick={() => {
            setViewModalData(null);
            handleNewSubmission(viewModalData);
          }} className="btn-primary flex items-center" data-id="element-1214">
                <PlusCircle size={16} className="mr-2" data-id="element-1215" />
                নতুন ডাটা সাবমিশন
              </button>
            </div>
          </div>
        </div>}
    </div>;
};